<div>
  &nbsp;
  @if (!editState) {
    <a uiSref="a.material.inventory.create" title="Artikel Einpflegen" class="btn btn-default">
      <span class="fa fa-plus"></span>
    </a>
  }
  @if (editState) {
    <material-edit-navigation>
    </material-edit-navigation>
  }
</div>
